import { render, staticRenderFns } from "./zingala-info-modal.vue?vue&type=template&id=77ff35f2"
import script from "./zingala-info-modal.vue?vue&type=script&lang=js"
export * from "./zingala-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports